import { LOGO_URL, NAV_LINKS, SLOGAN, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[var(--mpg-bg)] border-t border-[var(--mpg-border)]" data-testid="footer">
      <div className="max-w-[1800px] mx-auto px-8 md:px-16 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-12">
          <div>
            <img src={LOGO_URL} alt="Madison Price Group" className="brand-logo object-contain mb-6" />
            <p className="font-serif italic text-xl md:text-2xl text-[var(--mpg-text)] max-w-sm">
              {SLOGAN}
            </p>
            <div className="mt-6 flex flex-col gap-2">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="font-mono text-xs text-[var(--mpg-text-soft)] hover:text-[var(--mpg-text)] transition-colors"
                data-testid="footer-email"
              >
                {CONTACT_EMAIL}
              </a>
              <a
                href={CONTACT_PHONE_HREF}
                className="font-mono text-xs text-[var(--mpg-text-soft)] hover:text-[var(--mpg-text)] transition-colors"
                data-testid="footer-phone"
              >
                {CONTACT_PHONE}
              </a>
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--mpg-text-soft)] hover:text-[var(--mpg-text)] transition-colors duration-300"
                data-testid={`footer-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-16 pt-8 border-t border-[var(--mpg-border)] flex flex-col md:flex-row justify-between gap-4">
          <p className="font-mono text-xs text-[var(--mpg-text-soft)]">
            © {year} Madison Price Group LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a
              href="https://getoliveup.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-[var(--mpg-text-soft)] hover:text-[var(--mpg-text)] transition-colors"
              data-testid="footer-oliveup"
            >
              OliveUp
            </a>
            <a
              href="https://mygreenhalo.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-[var(--mpg-text-soft)] hover:text-[var(--mpg-text)] transition-colors"
              data-testid="footer-greenhalo"
            >
              My Green Halo
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
